import Swiper from "swiper/bundle";

const CategoriesSlider = () => {
  const categoriesSlider = document.querySelector('.categories__slider');
  
  if (categoriesSlider) {
    const categoriesCarousel = new Swiper(categoriesSlider, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: '.categories__slider-button-next',
        prevEl: '.categories__slider-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1440: {
          slidesPerView: 3,
        },
      },
    });
  }
};

export default CategoriesSlider;
